// src/components/ShopPage.js (Updated Version)

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- Import useNavigate
import ProductCard from './ProductCard'; 
import logoSrc from '../img/logo.png';
import ContactForm from '../ContactForm';
import './About.css'; 

const ShopPage = () => {
  const contactFormRef = useRef();
  const navigate = useNavigate(); // <-- Initialize the hook

  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm();
    }
  };

  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');

  // --- useEffect hook remains the same, no changes needed here ---
  useEffect(() => {
    fetch('https://apiqms.shigjeta.com/api/products')
      .then((response) => response.text())
      .then((text) => {
        const data = JSON.parse(text); // Simplified processing for clarity
        setProducts(data);
      })
      .catch((error) => {
        console.error('Error loading product data:', error);
      });
  }, []);

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  // <-- NEW: This function will handle the navigation -->
  const handleProductClick = (productId) => {
    navigate(`/shigjeta-shop/${productId}`);
  };

  return (
    <>
      {/* Hero and other sections remain unchanged... */}
      {/* ... */}
      
      {/* Product List Section */}
      <section className="shop-products" id="products">
        {/* ... shop-header and shop-category-filter remain the same ... */}
        
        <div className="shop-product-list">
           {filteredProducts.length > 0 ? (
    filteredProducts.map((product) => (
      <ProductCard
        key={product.id}
        product={product} // Now, you only pass the product data
      />
    ))
          ) : (
            <p>No products found in this category.</p>
          )}
        </div>
      </section>

      {/* <-- REMOVED: The entire ProductModal section is gone --> */}

      {/* Call to Action Section and ContactForm remain unchanged... */}
      {/* ... */}
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default ShopPage;